import { Component, OnInit, NgZone } from '@angular/core';
import { AmbitService } from '../ambit.service';
import * as firebase from 'firebase';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-drivers',
  templateUrl: './drivers.component.html',
  styleUrls: ['./drivers.component.css']
})
export class DriversComponent implements OnInit {

  public driversList: any = [];
  public searchList: any = ['userName', 'email'];
  public sortColumn: any = 'status';
  public sortType: boolean = true;

  public driverForm: FormGroup;
  public submitted: boolean = false;
  public loading: boolean = false;
  public selectedFile: any;
  public imgURL: any;

  constructor(private formBuilder: FormBuilder,
    public router: Router,
    public zone: NgZone,
    public http: HttpClient,
    private toastr: ToastrService,
    public route: ActivatedRoute,
    public service: AmbitService) {

    if (this.service.adminUser.userAccess.drivers == 'None') {
      this.router.navigate(['/home']);
    }

  }

  ngOnInit() {
    var self = this;
    self.driverForm = self.formBuilder.group({
      userName: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(20)]],
      email: ['', Validators.compose([
        Validators.required,
        Validators.pattern('^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$'),
      ])],
      password: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(10)]],
      dob: ['', Validators.required],
      profileImage: [''],
      phoneNo: ['', [Validators.required, Validators.minLength(9), Validators.maxLength(14)]],
      licenseNo: ['', [Validators.required, Validators.minLength(9), Validators.maxLength(16)]],
      nic: ['', [Validators.required, Validators.minLength(9), Validators.maxLength(16)]]
    });

  }

  toggleSortValue(val) {
    if (this.sortColumn == val) { this.sortType = !this.sortType; }
    else { this.sortColumn = val; }
  }

  get f() { return this.driverForm.controls; }

  isValidBirthday() {
    var sDt = new Date(this.driverForm.get('dob').value), cDt = new Date(), cYear = cDt.getFullYear(),
      sYear = sDt.getFullYear() + 17, cMonth = cDt.getMonth(), sMonth = sDt.getMonth();

    return (cYear > sYear || (cYear == sYear && (cMonth > sMonth || (cMonth == sMonth && cDt.getDate() >= sDt.getDate()))));
  }

  onChangeFile(event: EventTarget) {

    let eventObj: MSInputMethodContext = <MSInputMethodContext>event;
    let target: HTMLInputElement = <HTMLInputElement>eventObj.target;
    this.selectedFile = target.files[0];
    this.driverForm.get("profileImage").setValue(this.selectedFile);

    const file = target.files[0];
    const reader = new FileReader();
    reader.onload = e => this.imgURL = reader.result;
    reader.readAsDataURL(file);
  }

  submitDriverData() {
    var self = this;
    self.submitted = true;
    if (this.driverForm.valid && this.selectedFile) {
      self.submitted = false;
      self.loading = true;
      var data = self.driverForm.value;
      var createUser = firebase.functions().httpsCallable('createUser');
      createUser({
        name: data.userName,
        email: data.email,
        password: data.password,
      }).then((result) => {
        if (result.data.status == 200) {
          self.uploadPhoto(result.data.data.uid);
        } else {
          self.loading = false;
          self.toastr.error(result.data.data.errorInfo.message, '', { timeOut: 4000 });
        }
      }).catch((error) => {
        self.loading = false;
        self.toastr.error(error.message, '', { timeOut: 4000 });
      });
    }
  }

  uploadImageFile(formData: FormData) {
    return this.http.post("https://codexia.xyz/ambit/upload.php", formData).toPromise();
  }

  uploadPhoto(userId: any) {
    var self = this;
    var formDataIntroV: FormData = new FormData();
    formDataIntroV.append('file', this.selectedFile);
    this.uploadImageFile(formDataIntroV).then((res: any) => {
      if (res.success) {
        self.saveUserData(res.fileUrl, userId);
      } else {
        self.loading = false;
        self.toastr.error(res.message, '', { timeOut: 4000 });
      }
    }).catch(err => {
      self.loading = false;
      self.toastr.error("Error Uploading Image", '', { timeOut: 4000 });
    });

  }

  saveUserData(url: any, uid: any) {

    var self = this, data = self.driverForm.value;
    var formData = {
      userName: data.userName,
      birthday: data.dob,
      phoneNo: data.phoneNo,
      email: data.email,
      driver: true,
      uid: uid,
    };

    var licenseData = {
      drivingLicense: data.licenseNo,
      nicNo: data.nic,
      status: 'Pending',
      uid: uid,
      timeSatmp: Number(new Date()),
    }

    if (url) { licenseData['documentFiles'] = [url]; }

    var updates = {}, docID = firebase.database().ref().child('DriverDocuments/').push().key;
    updates['/Users/' + uid] = formData;
    updates['/DriverDocuments/' + docID] = licenseData;

    firebase.database().ref().update(updates).then(() => {
      self.driverForm.reset();
      document.getElementById('closeAddDriverMd').click();
      self.toastr.success('New Dirver Account created.', '', { timeOut: 4000 });
    }).catch((err) => {
      self.loading = false;
      self.toastr.error('Dirver account data is not saved.', '', { timeOut: 4000 });
    });

  }

}